const SERVICE_REGEX = /^[\/]*([^\/]+)(?:\/.*)?$/;
export default (config => {
  // While using miagejs server I noticed that it didn't return config object
  // during error cases, this code was eating actual error and throwing "can't
  // access url on undefined" error that made it difficult to identify the
  // real issue. That was non productive for me.
  // While using request interceptor to cancel request during scoped unit tests,
  // axios returns an error that doesn't have config and this code fails.
  // Since this was surfaced in testing, add a check for config to be safe.
  if (config === undefined) {
    // possible during tests.
    return null;
  }
  return getServiceNameFromUrl(config.url);
});
export const getServiceNameFromUrl = url => {
  // just handle relative urls as non relative urls could be cross origin and/or non SAS endpoints
  if (typeof url !== 'string' || url[0] !== '/') {
    return null;
  }
  const matches = SERVICE_REGEX.exec(url);
  if (!matches) {
    return null;
  }
  return matches[1];
};
//# sourceMappingURL=getServiceName.js.map